import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ManufacturerCatalogApi } from '~/app/services/knowledgeBase/catalog.api';
import { assetTypesApi } from '~/app/services/knowledgeBase/api-instances';

export function useUnresolvedCatalogOptions() {
  // Share cache keys with the catalog tab (useErrorManagementPage).
  const manufacturersQuery = useQuery({
    queryKey: ['vendor-error-code-manufacturers'],
    queryFn: () => ManufacturerCatalogApi.list({ page: 1, limit: 1000 }),
  });

  const assetTypesQuery = useQuery({
    queryKey: ['vendor-error-code-asset-types'],
    queryFn: () =>
      assetTypesApi.assetTypeControllerFindAll({ page: 1, limit: 1000 }),
  });

  const manufacturerOptions = useMemo(
    () =>
      (manufacturersQuery.data?.data ?? []).map((item) => ({
        label: item.name,
        value: item.id,
      })),
    [manufacturersQuery.data],
  );

  const assetTypeOptions = useMemo(
    () =>
      (assetTypesQuery.data?.data ?? []).map((item) => ({
        label: item.name,
        value: item.id,
      })),
    [assetTypesQuery.data],
  );

  return { manufacturerOptions, assetTypeOptions };
}
